/* eslint-disable react/no-unused-state */
import React, { Component } from "react";

import {
  CButton,
  CListGroup,
  CListGroupItem,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import CorrectQuestion from "../CorrectQuestion";
import Loading from "../Loading";

import "./styles.css";

class CorrectQuestionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allocation_id: this.props.allocation_id,
      listId: this.props.id,
      loading: true,
      prototype: this.props.prototype,
      finished: false,
      showPhoto: this.props.showPhoto,

      name: undefined,
      questions: [],
      simulated: false,
      random: false,
      time: null,
      start: { fullDate: undefined, timeStamp: undefined },
      end: undefined,
      value: null,
      executions: 0,
      randomizer: [],
      applications: [],

      answers: {
        score: 0,
        scoreValue: 0,
        answers: []
      },

      try: null,
      photo: ""
    };

    this.listAnswerChanger = this.changeListAnswers.bind(this);
  }

  componentDidMount() {
    const startMark = this.getCurrentDate();
    this.setState({
      start: {
        fullDate: startMark.currentTime,
        timeStamp: startMark.timeStamp
      }
    });

    this.pullApplications(() => this.pullList());
  }

  pullApplications(callback = () => null) {
    const filter = {
      user_id: this.props.user_id,
      allocation_id: this.state.allocation_id,
      list_id: this.state.listId,
      ended: true
    };
    axios
      .post(`${URL.api}evaluation/application/list`, filter, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        const bestTry = resp.data.data.reduce((acc, val) => {
          if (acc) {
            if (
              parseFloat(val.final_grade) >
              parseFloat(
                resp.data.data.find(item => item.try === acc).final_grade
              )
            ) {
              return val.try;
            }

            return acc;
          }

          return val.try;
        }, null);

        this.setState(
          {
            applications: resp.data.data,
            try: bestTry,
            photo: resp.data.data[0]?.photo
          },
          () => callback()
        );
      });
  }

  pullList() {
    axios
      .get(
        `${URL.api}evaluation/question/lists/singleView/${this.state.listId}`,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {
        if (resp.data.success) {
          const applicationAnswers = this.state.applications.find(
            application => application.try === this.state.try
          )?.answers;

          const questionsArray = resp.data.data.questions.map(question => ({
            id: question.id,
            value: question.value
          }));

          const answersArray = resp.data.data.questions.map(answer => {
            const applicationAnswer = applicationAnswers?.find(
              applicationAnswer => applicationAnswer.question_id === answer.id
            );
            return {
              id: applicationAnswer?.id,
              questionId: answer.id,
              answer_given: applicationAnswer?.answer_given,
              correction: applicationAnswer?.correct,
              answer: JSON.parse(applicationAnswer?.answer || "{}"),
              value: applicationAnswer?.value
            };
          });
          const newScore = this.sumUserScore(answersArray);
          const correctionsArray = {
            score: newScore.rawValue,
            scoreValue: Number(newScore.finalValue) * resp.data.data.value,
            answers: answersArray
          };

          this.setState({
            listId: resp.data.data.id,
            name: resp.data.data.name,
            questions: questionsArray,
            simulated: resp.data.data.simulated,
            random: resp.data.data.random,
            time: resp.data.data.time,
            value: resp.data.data.value,
            currentValueSum: resp.data.data.value,
            executions: resp.data.data.execution_quantity,
            randomizer: resp.data.data.randoms,

            answers: correctionsArray,

            loading: false
          });
        }
      });
  }

  changeTry(newTry) {
    const applicationAnswers = this.state.applications.find(
      application => application.try === newTry
    ).answers;

    const answersArray = this.state.questions.map(answer => {
      const applicationAnswer = applicationAnswers.find(
        applicationAnswer => applicationAnswer.question_id === answer.id
      );
      return {
        id: applicationAnswer.id,
        questionId: answer.id,
        correction: applicationAnswer.correct,
        answer: JSON.parse(applicationAnswer.answer),
        value: applicationAnswer.value
      };
    });

    const newScore = this.sumUserScore(answersArray);
    const correctionsArray = {
      score: newScore.rawValue,
      scoreValue: Number(newScore.finalValue),
      answers: answersArray
    };

    this.setState({
      answers: correctionsArray,
      try: newTry
    });
  }

  getCurrentDate() {
    const timeStamp = new Date().getTime();

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const currentDay = new Date().getDate();
    const currentHour = new Date().getHours();
    const currentMinute = new Date().getMinutes();
    const currentSecond = new Date().getSeconds();

    const fullDate = `${currentYear}-${currentMonth}-${currentDay} ${currentHour}:${currentMinute}:${currentSecond}`;

    const timeSpent = Math.floor(
      (timeStamp - this.state.start.timeStamp) / 60000
    );

    return { currentTime: fullDate, timeStamp, timeSpent };
  }

  changeListAnswers(questionId, correctionValue, corretionGrade) {
    const correctionsArray = this.state.answers.answers.slice();
    const answerIndex = correctionsArray.findIndex(
      answer => answer.questionId === questionId
    );

    correctionsArray[answerIndex].correction = correctionValue;
    correctionsArray[answerIndex].value = corretionGrade;

    const newScore = this.sumUserScore(correctionsArray);
    const answersArray = {
      score: newScore.rawValue,
      scoreValue: Number(newScore.finalValue),
      answers: correctionsArray
    };

    this.setState({ answers: answersArray });
  }

  sumUserScore(newAnswersArray) {
    const answersArray = [...newAnswersArray];
    const correctedValuesArray = answersArray
      .filter(answer => answer.correction)
      .map(answer => Number(answer.value));
    const rawValue = correctedValuesArray.length;
    const finalValue = rawValue / answersArray.length;
    return { rawValue, finalValue };
  }

  correctListApplication() {
    if (this.state.answers.scoreValue > this.state.value) {
      toastr.error("Você inseriu uma nota superior ao valor da atividade!");
      return;
    }

    const answersArray = this.state.answers.answers.map(answer => ({
      id: answer.id,
      correct: answer.correction,
      value: Number(answer.value)
    }));

    const application = this.state.applications.find(
      application => application.try === this.state.try
    );

    const obj = {
      id: application.id,
      correct_answers: this.state.answers.score,
      final_grade: this.state.answers.scoreValue,
      answers: answersArray,
      item_id: this.props.item_id,
      execution_id: this.props.execution_id
    };

    axios
      .post(`${URL.api}evaluation/application/correct`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(response => {
        if (response.data?.success) {
          toastr.success("Finalizado!", "Avaliação corrigida com sucesso");
        }

        this.setState(state => ({
          applications: state.applications.map(item =>
            item.id === application.id
              ? {
                  ...application,
                  correct_answers: state.answers.score,
                  final_grade: state.answers.scoreValue
                }
              : item
          )
        }));
      });
  }

  render() {
    if (this.state.loading && !this.state.showPhoto) {
      return (
        <CModal
          onClose={this.props.onClose}
          show={this.props.show}
          centered
          size="xl w-100 h-100 m-0 p-2 mw-100"
          style={{ width: "80%", height: "80%" }}
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle>Correção de lista de questões</CModalTitle>
          </CModalHeader>
          <CModalBody
            className="p-3 d-flex align-items-center justify-content-center"
            style={{ overflow: "auto" }}
          >
            <Loading />
          </CModalBody>
        </CModal>
      );
    }

    if (this.state.applications.length === 0 && !this.state.showPhoto) {
      return (
        <CModal
          onClose={this.props.onClose}
          show={this.props.show}
          centered
          size="xl w-100 h-100 m-0 p-2 mw-100"
          style={{ width: "100%", height: "100%" }}
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle>Correção de lista de questões</CModalTitle>
          </CModalHeader>
          <CModalBody
            className="p-3 d-flex align-items-center justify-content-center"
            style={{ overflow: "auto" }}
          >
            <h3 className="m-0">Nenhuma tentativa realizada</h3>
          </CModalBody>
        </CModal>
      );
    }

    if (this.state.showPhoto === true) {
      if (this.state.loading) {
        return (
          <CModal
            onClose={this.props.onClose}
            show={this.props.show}
            centered
            size="xl w-100 h-100 m-0 p-2 mw-100"
            style={{ width: "100%", height: "100%" }}
            closeOnBackdrop={false}
          >
            <CModalHeader closeButton>
              <CModalTitle>Cartão resposta</CModalTitle>
            </CModalHeader>
            <CModalBody
              className="p-3 d-flex align-items-center justify-content-center"
              style={{ overflow: "auto" }}
            >
              <Loading />
            </CModalBody>
          </CModal>
        );
      }

      if (this.state.photo === "" || this.state.photo === null) {
        return (
          <CModal
            onClose={this.props.onClose}
            show={this.props.show}
            centered
            size="xl w-100 h-100 m-0 p-2 mw-100"
            style={{ width: "100%", height: "100%" }}
            closeOnBackdrop={false}
          >
            <CModalHeader closeButton>
              <CModalTitle>Cartão resposta</CModalTitle>
            </CModalHeader>
            <CModalBody
              className="p-3 d-flex align-items-center justify-content-center"
              style={{ overflow: "auto" }}
            >
              <h3 className="m-0">Nenhuma imagem capturada</h3>
            </CModalBody>
          </CModal>
        );
      }
      return (
        <CModal
          onClose={this.props.onClose}
          show={this.props.show}
          centered
          size="xl w-100 h-100 m-0 p-2 mw-100"
          style={{ width: "100%", height: "100%" }}
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle>Ver cartão reposta</CModalTitle>
          </CModalHeader>
          <CModalBody
            className="p-3 d-flex align-items-center justify-content-center"
            style={{ overflow: "auto" }}
          >
            <img
              src={URL.img + this.state.photo}
              alt=""
              width="50%"
              height="100%"
            />
          </CModalBody>
        </CModal>
      );
    }

    return (
      <CModal
        onClose={this.props.onClose}
        show={this.props.show}
        centered
        size="xl w-100 h-100 m-0 p-2 mw-100"
        style={{ width: "100%", height: "100%" }}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>Correção de lista de questões</CModalTitle>
        </CModalHeader>
        <CModalBody className="p-0 d-flex" style={{ overflow: "auto" }}>
          <CListGroup
            style={{
              height: "100%",
              backgroundColor:
                "#f6f8f9" /* , borderRight:"1px solid rgba(0, 0, 21, 0.125)" */
            }}
          >
            {this.state.applications.map(item => (
              <CListGroupItem
                action
                active={item.try === this.state.try}
                key={item.id}
                className="cursor"
                style={{ border: "0", borderRadius: "0", minWidth: "250px" }}
                onClick={() => this.changeTry(item.try)}
              >
                Tentativa {item.try} (Nota: {item.final_grade})
              </CListGroupItem>
            ))}
          </CListGroup>
          <div
            className="flex-1 d-flex flex-column align-items-center"
            style={{ overflow: "auto" }}
          >
            <div className="applicated-question-list-container">
              <section className="applicated-question-list-info-section">
                <h1>{this.state.name}</h1>
                <section>
                  {this.state.time === 0 ? (
                    <h5>Duração da lista: Sem Limite</h5>
                  ) : (
                    <h5>Duração da lista: {this.state.time} minutos</h5>
                  )}
                </section>
                <section>
                  <h5>Valor da Prova: {this.state.value}</h5>
                </section>
              </section>
              <section className="applicated-qeustion-list-question-section">
                <ul>
                  {this.state.questions.map(question => (
                    <li key={`${question.id}-${this.state.try}`}>
                      <CorrectQuestion
                        questionId={question.id}
                        listId={this.state.listId}
                        prototype={false}
                        listApplication
                        history={this.props.history}
                        listAnswerChanger={this.listAnswerChanger}
                        value={question.value}
                        answers={this.state.answers}
                        answer={this.state.applications
                          ?.find(
                            application => application.try === this.state.try
                          )
                          .answers?.find(
                            answer => answer.question_id === question.id
                          )}
                      />
                    </li>
                  ))}
                </ul>
              </section>
              <section className="applicated-question-list-navigation-menu">
                <span
                  className={`font-weight-bold mr-2${
                    this.state.answers.scoreValue > this.state.value
                      ? " text-danger"
                      : ""
                  }`}
                >
                  Nota: {this.state.answers.scoreValue.toFixed(2)}&nbsp;
                </span>
                {/* <CButton
                  color="primary"
                  onClick={() => this.correctListApplication()}
                >
                  Salvar
                </CButton> */}
              </section>
            </div>
          </div>
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CorrectQuestionList);
